import { getShowArchivedInSelects } from './showArchived';

// FIN-1211: GraphQL operations that declare an `$includeArchived` variable
// (the company/vessel select queries) get the global "show archived in selects"
// flag injected, so archived options are revealed across every GraphQL select
// when an admin turns the toggle on. Operations without the variable are left
// untouched (the server would reject an undeclared variable).
export const declaresIncludeArchived = (operation) =>
  ((operation && operation.query && operation.query.definitions) || []).some(
    (def) =>
      def.kind === 'OperationDefinition' &&
      (def.variableDefinitions || []).some(
        (v) => v.variable && v.variable.name && v.variable.name.value === 'includeArchived'
      )
  );

export const applyShowArchived = (operation) => {
  if (!declaresIncludeArchived(operation)) return;
  operation.variables = {
    ...operation.variables,
    includeArchived: getShowArchivedInSelects(),
  };
};
